import React from 'react';
import { Button } from '../../../../../../ui';
import { CloseIcon, PencilIcon, SolidCheckIcon } from '../../../../../../ui/icons/icons';

interface SettingsCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  isEditing: boolean;
  isSaving: boolean;
  onEditToggle: () => void;
  onSave: () => void;
  children: React.ReactNode;
}

export const SettingsCard: React.FC<SettingsCardProps> = ({
  title,
  description,
  icon,
  isEditing,
  isSaving,
  onEditToggle,
  onSave,
  children,
}) => {
  return (
    <div className='bg-white rounded-lg border border-gray-200 shadow-sm'>
      { /* Header */ }
      <div className='px-6 py-4 border-b border-gray-200'>
        <div className='flex items-center justify-between'>
          <div className='flex items-center gap-3'>
            <div className='w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center'>
              { icon }
            </div>
            <div>
              <h2 className='text-lg font-semibold text-gray-900'>{ title }</h2>
              <p className='text-sm text-gray-500'>{ description }</p>
            </div>
          </div>

          { /* Action Buttons */ }
          <div className='flex items-center gap-2'>
            { isEditing ? (
              <>
                <Button
                    label='Cancel'
                    variant='secondary'
                    onClick={onEditToggle}
                    disabled={isSaving}
                    hasIcon={true}
                    icon={<CloseIcon />}
                    className='px-3 py-2 text-sm'
                />
                <Button
                    label={isSaving ? 'Saving...' : 'Save Changes'}
                    variant='primary'
                    onClick={onSave}
                    disabled={isSaving}
                    hasIcon={true}
                    icon={isSaving ? (
                      <div className='w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin' />
                    ) : (
                      <SolidCheckIcon />
                    )}
                    className='px-3 py-2 text-sm'
                />
              </>
            ) : (
              <Button
                  label='Edit'
                  variant='secondary'
                  onClick={onEditToggle}
                  hasIcon={true}
                  icon={<PencilIcon />}
                  className='px-3 py-2 text-sm'
              />
            ) }
          </div>
        </div>
      </div>

      { /* Content */ }
      <div className='px-6 py-6'>
        <div className='space-y-6'>
          { children }
        </div>
      </div>
    </div>
  );
};
